 //--
import request from "../../../core/wrappers/axios-wrapper";
import { ApiURL } from "../../../types/constants/apiUrls/api-urls";
import { RequestType } from "../../../types/enums/request-enums";
 //#region comment metod 
 const PostGetSearchInformation = (data: any): Promise<any>  =>
 request({ 
   url: ApiURL.Command.PostGetSearchInformation,
   method: RequestType.POST,
   data,
 });
 const GetStockByProduct = (data: any): Promise<any>  =>
 request({ 
   url: ApiURL.Command.GetStockByProduct,
   method: RequestType.POST,
   data,
 }); 
 const UpdateLastSync = (data: any): Promise<any>  =>
 request({ 
   url: ApiURL.Command.InventoryLastSync,
   method: RequestType.POST,
   data,
 });
 const GetOptionSummary = (data: any): Promise<any>  =>
 request({ 
   url: ApiURL.Command.GetOptionSummary,
   method: RequestType.POST,
   data,
 });
 const GetSummariesHistory = (data: any): Promise<any>  =>
 request({ 
   url: ApiURL.Command.GetSummariesHistory,
   method: RequestType.POST,
   data,
 });       
 const GetProductAvailableStock = (data: any): Promise<any>  =>
 request({ 
   url: ApiURL.Command.GetProductAvailableStock,
   method: RequestType.POST,
   data,
 }); 
 const GetBarcodeBySpecialAndColorCodeList = (data: any): Promise<any>  =>
 request({ 
   url: ApiURL.Command.GetBarcodeBySpecialAndColorCodeList,
   method: RequestType.POST,
   data,
 }); 
const searchServiceCommand = {
  PostGetSearchInformation ,
  GetStockByProduct,
  UpdateLastSync,
  GetOptionSummary,
  GetSummariesHistory,
  GetProductAvailableStock,
  GetBarcodeBySpecialAndColorCodeList

}

export default searchServiceCommand;
